import { useSettings } from '@/store/settingsStore';
import SoundOnIcon from '@/assets/icons/sound-on.svg';
import SoundOffIcon from '@/assets/icons/sound-off.svg';
import { cn } from '@/ui/lib/utils';
import { Icon } from '../Icon/Icon';
import { Button } from '../Button/Button';
import './soundToggle.css';

interface SoundToggleProps {
    className?: string;
}

export const SoundToggle = ({ className }: SoundToggleProps) => {
    const { muted, mute, unmute } = useSettings();

    const toggleSound = () => (muted ? unmute() : mute());

    return (
        <Button className={cn('sound-toggle', className)} variant="ghost" onClick={toggleSound}>
            Sound {muted ? 'off' : 'on'}
            <div className="sound-toggle__icon-container">
                <Icon className="sound-toggle__icon" src={SoundOffIcon} />
                <Icon
                    className={cn('sound-toggle__icon', muted && 'sound-toggle__icon--hidden')}
                    src={SoundOnIcon}
                />
            </div>
        </Button>
    );
};
